// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { icon } from '../../tokens/themeColors/icon';
import { text } from '../../tokens/themeColors/text';
export var selectBoxColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var ic = icon(mode);
    var tx = text(mode);
    // Sibling-label tokens (labelText, hintText, placeholderText on default/disabled/error)
    // target MuiInputLabel and MuiFormHelperText, which are FormControl siblings — not
    // descendants of MuiSelect. They cannot be wired through MuiSelect overrides and are
    // applied globally in TextField.tsx. Kept here for parity with Figma Component Colors.
    return {
        active: {
            border: bd.action200,
            icon: ic.active
        },
        default: {
            background: bg.level0,
            border: bd.heavy,
            hintText: tx.secondary,
            icon: ic.heavy,
            labelText: tx.secondary,
            placeholderText: tx.tertiary,
            text: tx.primary
        },
        disabled: {
            background: bg.state.disabledTransparent,
            border: bd.default,
            hintText: tx.disabled,
            icon: ic.disabled2,
            labelText: tx.disabled,
            text: tx.disabled3
        },
        error: {
            border: bd.status.error,
            hintText: tx.status.errorAlt,
            labelText: tx.status.errorAlt
        },
        hover: {
            background: bg.level50,
            border: bd.active,
            icon: ic.active
        },
        readonly: {
            border: bd.default,
            hintText: tx.secondary,
            icon: ic.disabled,
            labelText: tx.secondary,
            placeholderText: tx.tertiary,
            text: tx.secondary
        }
    };
};

//# sourceMappingURL=selectBoxColors.js.map